import { createAction } from 'redux-act';
import { IShippingReducer, UpdateCreateCustomerPayload } from 'modules/ScrShop/store/types';

export const setShippingValueAction = createAction<Partial<IShippingReducer>>('SET_SHIPPING_VALUE');

export const createUpdateCustomerAction = createAction<UpdateCreateCustomerPayload>(
  'CREATE_UPDATE_CUSTOMER_ACTION'
);
export const loginCustomerAction = createAction('LOGIN_CUSTOMER_ACTION');
